import React from 'react'

const Pagetitle = props => <h1 className="my-5 text-3xl">{props.title}</h1>

export default Pagetitle
